import { StudentWarningsSummaryBuildDetailsURLParams } from './types';

export const buildDetailsURL = (
  enrollmentId: string | number,
  params: StudentWarningsSummaryBuildDetailsURLParams,
) => {
  let startAt = params.startAt || 'NULL';
  let endAt = params.endAt || 'NULL';
  return `/student-warnings/details/${enrollmentId}/${params.periodId}/${params.year}/${params.warningGroupType}/${startAt}/${endAt}`;
};
